__webpack_require__.p = "/assets/turbo/61a5e65f/ackermannch/_next/";